<template>
  <div>
    <question-select
      v-bind="$attrs"
      v-on="$listeners"
      id="batterySelector-question"
      :options="options"
      :value="value"
      :name="name"
      :data-vv-name="name"
      v-validate="validation"
      @input="handleInput"
    />
  </div>

</template>

<script>
import QuestionSelect from './QuestionSelect.vue';

export default {
  name: 'question-battery-select',
  props: ['validation', 'value', 'name'],
  inject: ['program'],
  components: { QuestionSelect },
  data() {
    return {
      options: [],
    };
  },
  watch: {
    value(val) {
      if (val != null) {
        if (this.options.find(({ value }) => value == null)) {
          this.options.shift();
        }
      }
      if (val === 'true') {
        this.$root.$emit('modal.show', 'tesla');
      }
    },
  },
  mounted() {
    this.options.push(
      { value: null, label: 'Select one' },
      { value: 'true', label: 'step1BatterySelect.options.true' },
      { value: 'false', label: 'step1BatterySelect.options.false' },
    );
  },
  methods: {
    handleInput(value) {
      this.$emit('input', value);
    },
  },
};
</script>

<style scoped>
.batterySelect-warning {
  float: left;
  margin-top: -18px;
  margin-bottom: 8px;
}
</style>
